import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/lib/auth';

interface LanguageLabAccess {
  enabled: boolean;
  loading: boolean;
  enabledAt: string | null;
}

export function useLanguageLabAccess(): LanguageLabAccess {
  const { user } = useAuth();
  const [enabled, setEnabled] = useState(false);
  const [enabledAt, setEnabledAt] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAccess = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('client_settings')
          .select('language_lab_enabled, language_lab_enabled_at')
          .eq('client_id', user.id)
          .maybeSingle();

        if (error) {
          console.error('Error fetching language lab access:', error);
          setEnabled(false);
        } else {
          setEnabled(data?.language_lab_enabled ?? false);
          setEnabledAt(data?.language_lab_enabled_at ?? null);
        }
      } catch (err) {
        console.error('Error fetching language lab access:', err);
        setEnabled(false);
      } finally {
        setLoading(false);
      }
    };

    fetchAccess();
  }, [user]);

  return { enabled, loading, enabledAt };
}